import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 100,
    transition: 'all 150ms ease-in-out',
    right: 0,
    // right: (useStylesParams) => (useStylesParams.open ? 0 : -88),
    // minWidth: 32,
    // maxWidth: 32,
    borderRadius: theme.shape.borderRadius,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    height: '10vh',
    backgroundColor: 'rgba(0,0,0,0)',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  button: {
    width: 32,
    height: 64,
    background: 'none !important',
    borderRadius: theme.shape.borderRadius,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    boxShadow: theme.shadows[3],
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dock: {
    backgroundColor: 'none !important',
    borderRadius: theme.shape.borderRadius,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    transition: 'all 150ms ease-in-out',
    flexDirection: 'column',
    // flexAlign: 'center',
    // justifyContent: 'center',
  },
  stage2: {
    height: '98vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    overflowX: 'auto',
    overflowY: 'hidden',
    cursor: 'grab',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
      height: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
}))

export default useStyles
